interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  label?: string;
}

export const SearchInput = ({ value, onChange, placeholder = 'Search', label }: SearchInputProps) => {
  return (
    <input
      type="search"
      aria-label={label ?? placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-64 px-3 py-2 text-sm rounded-lg border border-gray-200 focus:outline-none focus:border-gray-400"
    />
  );
};
